module.exports = __webpack_public_path__ + "static/img/03.b017289.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/03.jpg
// module id = 08US
// module chunks = 0